module.exports = __webpack_public_path__ + "img/test_12.e1703751.png";